import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

@Component({
    selector: 'app-marca-filter',
    templateUrl: './marca-filter.component.html',
    styleUrls: ['./marca-filter.component.scss'],
    standalone: false
})
export class MarcaFilterComponent implements OnInit {

  marcaList$: any;

  constructor(private selectionService: SelectionGenericService, public filterService: FilterService) {
    this.filterService.OnFiltersCleard.subscribe(res => {
      if (res) {
        this.InitializeMarcaList();
      }
    });
  }

  ngOnInit(): void {
    this.InitializeMarcaList();
  }

  InitializeMarcaList(): void {
    this.marcaList$ = [
      {
        text: 'Marca de empresa', value: 1, visible: this.selectionService.selectionPermissions.HasCompanyMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 1).length === 1
      },
      {
        text: 'Marca de medico', value: 2, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 2).length === 1
      },
      {
        text: 'Marca de coordinador', value: 3, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 3).length === 1
      },
      {
        text: 'Marca de mutua', value: 4, visible: this.selectionService.selectionPermissions.HasMutualityMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 4).length === 1
      },
      {
        text: 'Marca externa', value: 5, visible: this.selectionService.selectionPermissions.HasExternalMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 5).length === 1
      },
      {
        text: 'No citado por diagnóstico', value: 6, visible: this.selectionService.selectionPermissions.HasDiagnosisMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 6).length === 1
      },
      {
        text: 'No citado por zona', value: 7, visible: this.selectionService.selectionPermissions.HasZoneMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 7).length === 1
      },
      {
        text: 'Absentista', value: 8, visible: this.selectionService.selectionPermissions.HasAbsenteismMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 8).length === 1
      },
      {
        text: 'Actitud negativa', value: 9, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 9).length === 1
      },
      {
        text: 'Aviso de baja posterior al alta', value: 10, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 10).length === 1
      },
      {
        text: 'Crónicos', value: 11, visible: this.selectionService.selectionPermissions.HasChronicalMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 11).length === 1
      },
      {
        text: 'Embarazada', value: 12, visible: this.selectionService.selectionPermissions.HasPregnedMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 12).length === 1
      },
      {
        text: 'Empresas que no admiten bajas', value: 13, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 13).length === 1
      },
      {
        text: 'FPA anterior a hace una semana', value: 14, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 14).length === 1
      },
      {
        text: 'FPA anterior a próxima gestión', value: 15, visible: this.selectionService.selectionPermissions.HasDischargeDateBeforeTaskMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 15).length === 1
      },
      {
        text: 'Intervención quirúrgica', value: 16, visible: this.selectionService.selectionPermissions.HasSurgeryMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 16).length === 1
      },
      {
        text: 'Justificada con alerta', value: 17, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 17).length === 1
      },
      {
        text: 'No justificada', value: 18, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 18).length === 1
      },
      {
        text: 'No visitar', value: 19, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 19).length === 1
      },
      {
        text: 'Presentado inspección', value: 20, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 20).length === 1
      },
      {
        text: 'Prioritarias', value: 21, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 21).length === 1
      },
      {
        text: 'Recaída', value: 22, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 22).length === 1
      },
      {
        text: 'Recaídas con acumulación de 16 meses', value: 23, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 23).length === 1
      },
      {
        text: 'Recaídas con acumulación de 180 días', value: 24, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 24).length === 1
      },
      {
        text: 'Respuestas de inspección', value: 25, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 25).length === 1
      },
      {
        text: 'Sin FPA', value: 26, visible: this.selectionService.selectionPermissions.HasWithoutEstimatedMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 26).length === 1
      },
      {
        text: 'Sin gestionar', value: 27, visible: this.selectionService.selectionPermissions.HasWithoutManagingMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 27).length === 1
      },
      {
        text: 'Sin tareas ni orden de no visitar', value: 28, visible: this.selectionService.selectionPermissions.HasLeavesWithoutTasksMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 28).length === 1
      },
      {
        text: 'Sin visitas', value: 29, visible: this.selectionService.selectionPermissions.HasWithoutVisitsMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 29).length === 1
      },
      {
        text: 'Suspensión de complementos', value: 30, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 30).length === 1
      },
      {
        text: 'Urgente por puesto', value: 31, visible: this.selectionService.selectionPermissions.HasUrgentPositionMark,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 31).length === 1
      },
      {
        text: 'Marca de simulación', value: 32, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 32).length === 1
      },
      {
        text: 'Marca de salud mental', value: 33, visible: true,
        checked: this.selectionService.leaveSelectionModal.MarcaList.filter(marca => marca === 33).length === 1
      },
    ];
  }

  SetMarca(marca: any, element: MatCheckboxChange): void {
    const marcaValue = marca.value;
    if (element.checked) {
      this.selectionService.leaveSelectionModal.MarcaList.push(marcaValue);
    } else {
      const i = this.selectionService.leaveSelectionModal.MarcaList.indexOf(marcaValue);
      this.selectionService.leaveSelectionModal.MarcaList.splice(i, 1);
    }
  }

}
